export { default as OutOfStock } from "./OutOfStock";
